import { Directive } from '@angular/core';

import { Validator, AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';

import { parsePhoneNumberFromString  } from 'libphonenumber-js';

@Directive({
    selector: '[validatePhone]',
    providers: [{ provide: NG_VALIDATORS, useExisting: PhoneValidator, multi: true }],
    standalone: false
})
export class PhoneValidator implements Validator {

  validate(control: AbstractControl): ValidationErrors|null {
    if (control.value==null || control.value=='') return null;
    
    var phoneNumber = parsePhoneNumberFromString(control.value, "NZ");
    return (phoneNumber&&phoneNumber.isValid())? null: {'validatePhone': true};
  }
}